<template>
    <div>
    <order-list v-if="$route.path === '/all_orders'">
    </order-list>
    <open-order-list v-if="$route.path === '/open_orders'">
    </open-order-list>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import OrderList from "@/components/common/OrderList";
    import OpenOrderList from "@/components/common/OpenOrderList";

    export default {
        name: "OrderView",
        components: {OrderList, OpenOrderList},
        data: () => ({
        }),
        created() {
            this.$store.dispatch('auth/getProfile', this.user.id)
            this.$store.dispatch('autocomplete/getCountries')
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                countries: state => state.autocomplete.countries,
            })
        },
        methods: {
            ...mapActions('orders', [
                'getOrders',
                'getOrder',
                'addOrder'
            ]),
        }
    }
</script>

<style scoped>

</style>